import React, { useEffect, useState, useRef } from "react";
import { Navbar, Container } from "react-bootstrap";

// import Image
import logoLight from "../../assets/images/logo-light.png";
import logoDark from "../../assets/images/logo-dark.png";

import NavLink from "./NavLink";

import LangToggle from "../../components/toggle/LangToggle";
import useLang from "../../hooks/useLang";
import { ColorModeToggle } from "../../components/toggle/ColorModeToggle";
import NavDropdownNested from "./NavDropdownNested";

const Navbar1 = () => {
  const [locationHash, setLocationHash] = useState(() => window.location.hash || "#home");
  const [navClass, setnavClass] = useState("");
  const { lang } = useLang();

  const ourServiceItems = [
    {
      to: "/services/individual",
      title: lang.services.our_services.service_card_1_title
    },
    {
      to: "/services/accounting-compliance",
      title: lang.services.our_services.service_card_2_title
    },
    {
      to: "/services/assistance",
      title: lang.services.our_services.service_card_3_title
    },
    {
      to: "/services/advisory",
      title: lang.services.our_services.service_card_4_title
    },
    {
      to: "/services/documentation",
      title: lang.services.our_services.service_card_5_title
    },
    {
      to: "/services/dispute",
      title: lang.services.our_services.service_card_6_title
    },
    {
      to: "/services/diligence",
      title: lang.services.our_services.service_card_7_title
    },
    {
      to: "/services/registration",
      title: lang.services.our_services.service_card_8_title
    },
    {
      to: "/services/restitution",
      title: lang.services.our_services.service_card_9_title
    },
    {
      to: "/services/removal",
      title: lang.services.our_services.service_card_10_title
    },
    {
      to: "/services/exempetion",
      title: lang.services.our_services.service_card_11_title
    },
    {
      to: "/services/pricing",
      title: lang.services.our_services.service_card_12_title
    },
  ];

  useEffect(() => {
    // window.addEventListener("scroll", scrollNavigation, true);
    // return () => window.removeEventListener("scroll", scrollNavigation, true);
  }, []);

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setnavClass("nav-sticky");
    } else {
      setnavClass("");
    }

    const sections = document.querySelectorAll("section");
    window.onscroll = () => {
      var current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop - 60) {
          current = section.getAttribute("id");
        }
      });

      setLocationHash(`#${current}`);
    };
  }

  const navMenuRef = useRef(null);
  const toggleNavMenu = () => {
    navMenuRef.current.classList.toggle("collapse");
  };

  return (
    <React.Fragment>
      <div
        data-bs-spy="scroll"
        data-bs-target="#navbar"
        data-bs-offset="61"
        data-bs-smooth-scroll="true"
        className="scrollspy-example-2"
        // style={{ minHeight: "70px" }}
      >
        <nav className={`navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-light nav-sticky ${navClass}`} id="navbar">
          <Container fluid>
            <div className="navbar-nav" style={{ display: "flex", flexDirection: "row" }}>
              <Navbar.Brand className="logo text-uppercase">
                <NavLink to="/">
                  <img src={logoLight} loading="eager" className="logo-light" alt="" height="30" />
                  <img src={logoDark} loading="eager" className="logo-dark" alt="" height="30" />
                </NavLink>
              </Navbar.Brand>
              <LangToggle />
            </div>

            <div className="navbar-toggler-container">
              <ColorModeToggle style={{ marginRight: "1rem" }} />
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={toggleNavMenu}
              >
                <span className="mdi mdi-menu"></span>
              </button>
            </div>

            <div ref={navMenuRef} className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav ms-auto" id="navbar-navlist" style={{marginRight: 'auto'}}>
                <NavLink to="/" activeHref={locationHash}>
                  {lang.navigation.home}
                </NavLink>
                <li className="nav-item">
                  <NavDropdownNested title={lang.navigation.services} items={ourServiceItems} />
                </li>
                <NavLink to="/about-us" activeHref={locationHash}>
                  {lang.navigation.about_us}
                </NavLink>
                <NavLink to="/tax-updates" activeHref={locationHash}>
                  {lang.navigation.tax_updates}
                </NavLink>
              </ul>
              <div style={{marginLeft: '10%'}}>
                <ColorModeToggle className="navbar-color-mode-in-toggler" />
              </div>
            </div>
          </Container>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default Navbar1;
